import { NavBar } from 'components/NavBar/NavBar'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  Flex,
  TabsContainer,
  Tabs,
  H1WithBack,
  PageWrapper,
  ContentWrapper,
  TabFooter,
  Button,
  PageFooter,
} from 'styling/GlobalStyles'
import { useNavigate, useParams } from 'react-router-dom'
import { AppDispatch, RootState } from 'store'
import { IRoleTemplate } from 'types/roles.interface'
import { toast } from 'react-toastify'
import { PermissionsRolesTab } from 'pages/ResourcesAdmin/Roles/PermissionsRolesTab'
import { clearRoleTemplate, getSingleRoleTemplate, updateRoleTemplate } from 'features/roles/roleTemplatesSlice'
import { InfoRoleTemplatesTab } from './InfoRoleTemplatesTab'
import { Input } from 'components/Input/Input'
import { HonestSelectAsyncInput } from 'components/HonestAsyncSelect/HonestAsyncSelectInput'
import { CancelBtn } from 'components/Button/CancelBtn'

export const EditRoleTemplate = () => {
  const [active, setActive] = useState('Info')
  const { singleRoleTemplate } = useSelector((store: RootState) => store.roleTemplates)
  const dispatch = useDispatch<AppDispatch>()
  const navigate = useNavigate()
  const { id } = useParams()

  const [state, setState] = useState<IRoleTemplate>({
    name: '',
    id: parseInt(id),
    permissionPolicy: null,
  })

  useEffect(() => {
    dispatch(getSingleRoleTemplate(id))
    return () => {
      dispatch(clearRoleTemplate())
    }
  }, [])

  useEffect(() => {
    if (singleRoleTemplate) {
      setState(singleRoleTemplate)
    }
  }, [singleRoleTemplate])

  const handleSubmit = async () => {
    if (state.name.length < 1) {
      toast.warn('Role template name must be filled')
      return
    }

    const resp = await dispatch(updateRoleTemplate(state))
    if (resp.meta.requestStatus === 'fulfilled') {
      navigate('/resources-role-templates')
    }
  }



  const parsePolicies = (data: any) => {
    return data.data.map((item: any) => ({ label: item.policyName, value: item.id }))
  }

  return (
    <>
      <NavBar />
      <PageWrapper noFooter>
        <Flex between main>
          <H1WithBack mb='1.5' arrow title={'Edit ' + singleRoleTemplate ? singleRoleTemplate.name : ''} />

        </Flex>
        <Flex gap='1rem' column width='300px'>
          <Input name='name' value={state.name} labelText='Name' nomarg placeholder='Enter name...' onChange={e => setState(prev => ({ ...prev, name: e.target.value }))} />
          <HonestSelectAsyncInput nomarg parserFunction={parsePolicies} defaultValue={state.permissionPolicy?.label} onChange={v => setState(prev => ({ ...prev, permissionPolicy: v }))} labelText='Permission Policy Template' link='permission-policy/role-template' name='permissionPolicy' />
        </Flex>
      </PageWrapper>
      <PageFooter>
        <Flex end='true' gap='1em'>
          <CancelBtn />
          <Button orange type='button' onClick={handleSubmit}>
            Save
          </Button>
        </Flex>
      </PageFooter>
    </>
  )
}
